import ACTIONS from "./actions";

// Combined initial state for both step (status) and bar (matrix) charts
export const combinedInitialState = {
  status: {
    isLoading: false,
    isError: false,
    data: [],
  },
  matrix: {
    isLoading: false,
    isError: false,
    data: [],
  },
};

function stepChartReducer(state = combinedInitialState, action) {
  switch (action.type) {
    case ACTIONS.FETCH_CHARGER_STATUS_INIT: {
      return {
        ...state,
        status: { ...state.status, isLoading: true, isError: false },
      };
    }

    case ACTIONS.FETCH_CHARGER_STATUS_SUCCESS: {
      return {
        ...state,
        status: { ...state.status, isLoading: false, isError: false, data: action.payload },
      };
    }

    case ACTIONS.FETCH_CHARGER_STATUS_FAILURE: {
      return {
        ...state,
        status: { ...state.status, isLoading: false, isError: true },
      };
    }
    case ACTIONS.FETCH_CHARGER_MATRIX_INIT: {
      return {
        ...state,
        matrix: { ...state.matrix, isLoading: true, isError: false },
      };
    }

    case ACTIONS.FETCH_CHARGER_MATRIX_SUCCESS: {
      return {
        ...state,
        matrix: { ...state.matrix, isLoading: false, isError: false, data: action.payload },
      };
    }

    case ACTIONS.FETCH_CHARGER_MATRIX_FAILURE: {
      return {
        ...state,
        matrix: { ...state.matrix, isLoading: false, isError: true },
      };
    }

    default:
      return state;
  }
}

export default stepChartReducer;
